import { defineMessages } from 'react-intl-next';

export const nodeViewsMessages: {
    mediaGroupDeleteLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	mediaGroupDeleteLabel: {
		id: 'fabric.editor.mediaGroupDeleteLabel',
		defaultMessage: 'delete',
		description: 'a label for an icon that deletes media',
	},
});
